import { render, staticRenderFns } from "./WijkTitle.vue?vue&type=template&id=4fd2281c&"
import script from "./WijkTitle.vue?vue&type=script&lang=js&"
export * from "./WijkTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports